import { render } from "./ErrorMessage.vue?vue&type=template&id=01f8230d&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"

import "./ErrorMessage.vue?vue&type=style&index=0&id=01f8230d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/accounts.frontend/accounts.frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f8230d"]])

export default __exports__